/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/10/22
 */

import {gql} from "urql";
import {Employee, SubscriptionResponse} from "../../interfaces/Global";

export const EmployeesSubscription = gql`
    subscription Employees($employees: [String!]!) {
        employees(employees: $employees) {
            event
            data {
                id
                displayName
                company
                countryCode
                department
                division
                employeeId
                city
                firstName
                lastName
                location
                state
                timeZone
                tags
                phoneNumber
                personalTitle
                jobTitle
                emailAddress
                manager {
                    id
                    displayName
                }
                dateOfBirth
	            dateOfHire
                timeZone
                startTime
                endTime
                gsacOooEnabled
	            capacityModifier
	            properties
            }
        }
    }
`;

export interface EmployeesSubscriptionResponse {
	calendarEvents: SubscriptionResponse<Employee>
}

export interface EmployeesSubscriptionVars {
	employees: string[]
}